<template>
  <div class="pagination_box">
    <el-pagination
      background
      :current-page="Number(pageInfo.page)"
      :page-size="Number(pageInfo.limit)"
      :page-sizes="pageSizes"
      :layout="layout"
      :total="Number(pageInfo.total)"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />
  </div>
</template>

<script>
export default {
  props: {
    pageInfo: {
      type: Object,
    },
    layout: {
      type: String,
      default: () => {
        return "total, sizes, prev, pager, next, jumper";
      },
    },
    pageSizes: {
      type: Array,
      default: () => {
        return [10, 20, 30, 50];
      },
    }
  },
  methods: {
    // 切换页数
    handleCurrentChange(payload) {
      this.$emit("handleCurrentChange", payload);
    },
    // 切换每页条数
    handleSizeChange(payload) {
      this.$emit("handleSizeChange", payload);
    },
  },
};
</script>

<style lang="scss" scoped>
.pagination_box {
  width: 100%;
  display: flex;
  line-height: 30px;
  justify-content: center;
  padding: 16px 0 0;
  ::v-deep .el-pagination.is-background .el-pager li {
    // width: 32px;
    height: 32px;
    line-height: 30px;
    text-align: center;
    background-color: #ffffff;
    border: 1px solid #dcdee2;
    font-size: 14px;
    font-weight: normal;
    border-radius: 6px;
  }
  ::v-deep .btn-prev {
    width: 32px;
    height: 32px;
    line-height: 30px;
    text-align: center;
    background-color: #ffffff !important;
    border: 1px solid #dcdee2;
    font-size: 14px;
    font-weight: normal;
    border-radius: 6px;
  }
  ::v-deep .btn-prev:hover {
    color: #2d8cf0;
    border: 1px solid #2d8cf0;
  }
  ::v-deep .btn-next {
    width: 32px;
    height: 32px;
    line-height: 30px;
    text-align: center;
    background-color: #ffffff !important;
    border: 1px solid #dcdee2;
    font-size: 14px;
    font-weight: normal;
    border-radius: 6px;
  }
  ::v-deep .btn-next:hover {
    color: #2d8cf0;
    border: 1px solid #2d8cf0;
  }
  ::v-deep .el-pagination.is-background .el-pager li:hover {
    border: 1px solid #2d8cf0;
  }
  ::v-deep .el-pagination.is-background .el-pager .active {
    color: #2d8cf0;
    border: 1px solid #2d8cf0;
    background-color: #fff;
  }
  ::v-deep .el-pagination span:not([class*="suffix"]) {
    font-size: 14px;
    height: 32px;
    line-height: 32px;
  }
}
</style>
